const PHOTOS_PRINTED = 'Photos Printed';

const photosAnalyticsConstants = {
  PHOTOS_PRINTED,
};

export default photosAnalyticsConstants;
